import { render, staticRenderFns } from "./UsuarioEstado.vue?vue&type=template&id=0a4f5488"
import script from "./UsuarioEstado.vue?vue&type=script&lang=js"
export * from "./UsuarioEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports